exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "users-detail .panel.panel-warning label{font-weight:700}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/admin/users/users-detail/users-detail.styl
 ** module id = 410
 ** module chunks = 0
 **/